import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { button } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

const buildBtnSize = (size: 'small' | 'regular' | 'big'): SerializedStyles => {
    if (size !== undefined) {
        if (size === 'small') {
            return css`
                font-size: ${fontSize.small};
                padding: 2px 4px;
                line-height: 1.3334;
                height: 24px;
            `;
        }

        if (size === 'big') {
            return css`
                font-size: ${fontSize.xMedium};
                padding: 16px 0;
                height: 56px;
                width: 320px;
            `;
        }
    }

    return css`
        font-size: ${fontSize.xRegular};
        height: 40px;
        padding: 10px 12px;
    `;
};

const buildBtnVersion = (version: 'primary' | 'secondary', status: 'ok' | 'error' | 'default' | 'delete' | undefined): SerializedStyles => {
    if (version === 'secondary') {
        return css`
            background: ${button.secondary.bgColor};
            color: ${status === 'ok' ? button.secondary.ok.txtColor : status === 'error' || status === 'delete' ? button.secondary.error.txtColor : button.secondary.txtColor};
            border-style: solid;
            border-color: ${status === 'ok' ? button.secondary.ok.borderColor : status === 'error' || status === 'delete' ? button.secondary.error.borderColor : button.secondary.borderColor};
            border-width: 2px;
        `;
    }

    return css`
        background: ${status === 'ok' ? button.primary.ok.bgColor : status === 'error' || status === 'delete' ? button.primary.error.bgColor : button.primary.bgColor};
        color: ${button.primary.txtColor};
        border-style: solid;
        border-color: ${status === 'ok' ? button.primary.ok.borderColor : status === 'error' || status === 'delete' ? button.primary.error.borderColor : button.primary.borderColor};
        border-width: 2px;
    `;
};

type ButtonPropsType = {
    version: 'primary' | 'secondary';
    size: 'small' | 'regular' | 'big';
    width?: 'full' | 'default';
    status?: 'ok' | 'error' | 'default' | 'delete';
}

export const ButtonUniversal = styled('button', { label: 'ButtonUniversal' })<ButtonPropsType>`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    font-family: var(--fontFamilyPrimary);
    font-weight: ${fontWeight.bold};
    justify-content: center;
    min-width: fit-content;
    outline: none;
    transition: opacity 0.2s ease;
    width: ${({ width }): string => width === 'full' ? '100%' : 'fit-content'};
    ${({ status }): string => status === undefined || status === 'default' || status === 'delete' ? 'cursor: pointer' : 'pointer-events: none'};
    ${({ size }): SerializedStyles => buildBtnSize(size)};
    ${({ version, status }): SerializedStyles => buildBtnVersion(version, status)};

    &:hover {
        ${({ status }): string => status === undefined || status === 'delete' ? 'opacity: 0.8' : ''};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: .4;
        pointer-events: none;
    }
`;

interface ButtonOnInputSidePropsType {
    hasLabel?: boolean;
}

export const ButtonOnInputSide = styled(ButtonUniversal, { label: 'ButtonOnInputSide' })<ButtonOnInputSidePropsType>`
    margin: ${({ hasLabel }): string => hasLabel === false ? '0 0 0 24px' : '24px 0 0 24px'};
`;

export const ButtonsWrapper = styled('div', { label: 'ButtonsWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    > button:not(:first-of-type) {
        margin-left: 8px;
    }
`;

export const FormButtonsWrapper = styled(ButtonsWrapper, { label: 'FormButtonsWrapper' })`
    margin-top: 24px;
    align-items: flex-end;
`;
